var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"name":"pop"}},[(_vm.visible)?_c('div',{staticClass:"p-group-protocol"},[_c('CommonHeader',{attrs:{"back":_vm.close}},[_vm._v("圈子创建协议")]),_c('main',{staticClass:"m-art-body markdown-body",domProps:{"innerHTML":_vm._s(_vm.body)}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }